import React from "react";
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration';
import './App.css';
import './i18n'; // Import i18n configuration
import LayoutApp from "./components/LayoutApp";
import Auth from "./components/Auth";

// Configure Amplify
Amplify.configure(amplifyconfig);

function App() {
  return (
    <Auth>
      <LayoutApp />
    </Auth>
  );
}

export default App;